import { AxiosInstance } from "axios";
import { classToPlain } from "class-transformer";
import { BaseService, Page } from "yellowfin-ui-lib";
import {
  CountResponseWeb,
  LibriSearchRequest,
  Libro,
} from "../models/biblioteca.model";

export class BibliotecaService extends BaseService {
  constructor(http: AxiosInstance) {
    super(http);
  }

  search(request: LibriSearchRequest, page: Page): Promise<Libro[]> {
    return this.mapResponse(
      this.http.post(
        `web/biblioteca/search/range/${page.start}/${page.stop}`,
        classToPlain(request)
      ),
      Libro
    );
  }

  searchCount(request: LibriSearchRequest): Promise<CountResponseWeb> {
    return this.mapResponse(
      this.http.post(`web/biblioteca/search/count`, classToPlain(request)),
      CountResponseWeb
    );
  }

  getLibroById(
    id: number
  ): Promise<Libro | undefined> {
    const page = new Page(1);
    return this.search(new LibriSearchRequest(), page).then((results) => {
      const found = results.find((item) => item.id === id);
      if (found) {
        return found;
      }

      if (results.length === 0) {
        return undefined;
      }
    });
  }

  downloadCover(opaque: string): Promise<Blob> {
    return this.mapResponse(
      this.http.get(`download/x/${opaque}`, {
        responseType: "blob",
      })
    );
  }
}
